module.exports = __webpack_public_path__ + "img/client-1--small.png?f194aa5c0e3a6f135978c27d40aceaef";